import {combineActions, handleActions} from 'redux-actions';

const initialState = [];

const errors = handleActions({
  [combineActions('GET_COMPANIES_FAILURE', 'GET_PROGRAMS_FAILURE', 'GET_APPS_FAILURE', 'GET_TEAMS_FAILURE')]:
    (state, action) => ([...action.payload]),
  'CLEAR_ERRORS': () => {

    return [];
  }
}, initialState);

export default errors;


// WEBPACK FOOTER //
// ./src/components/utils/reducers/errors.js